import React, { useCallback } from 'react';
import { Grid } from 'components/FlexBox/FlexBox';
import { useDrawerDispatch } from 'context/DrawerContext';
import Button from 'components/Button/Button';
import { Plus } from 'assets/icons/PlusMinus';
import { useQuery, gql } from '@apollo/client';
import { Wrapper, Header, Heading } from 'components/Wrapper.style';
import CustomDataTable from "../../../components/DataTable/CustomDataTable";
import { Col, Row } from "./Variant.style"
import { GrEdit } from "react-icons/gr";

const VARIANT_QUERY = gql`query($query: QueryParams!) {
    productQuery {
      variationList(query: $query) {
        items {
          id
          name
          variationValues {
            active
            variationId
            value
          }
        }
      }
    }
  }`;

export default function Variant() {
    const dispatch = useDrawerDispatch();
    const { loading, data, refetch } = useQuery(VARIANT_QUERY, {
        variables: {
            query: {
                page: 1,
                pageSize: 10000
            }
        }
    });

    const openDrawer = useCallback(
        (id = 0) =>
            dispatch({ type: 'OPEN_DRAWER', drawerComponent: 'ADD_VARIANT', props: { "refetchVariants": refetch } }),
        [dispatch]
    );

    const columns = React.useMemo(
        () => [
            {
                Header: 'SL',
                accessor: 'sl',
                disableSortBy: true,
                disableFilters: true
            },
            {
                Header: 'Name',
                accessor: 'name',
            },
            {
                Header: 'Value',
                accessor: 'value',
                disableSortBy: true,
                disableFilters: true
            },
            {
                Header: 'Actions',
                accessor: 'actions',
                disableSortBy: true,
                disableFilters: true,
             }
        ],
        []
    );

    const hadnleEditVariant = useCallback(
        (id) =>
           dispatch({
              type: 'OPEN_DRAWER',
              drawerComponent: 'ADD_VARIANT',
              props: { variationItemId : id, "refetchVariants": refetch},
              data: { closeable: true },
           }),
        [dispatch]
     );

    const table = React.useMemo(
        () => {
            let variations = []
            if (data?.productQuery?.variationList?.items) {
                variations = data?.productQuery?.variationList?.items.map((c, i) => ({
                    sl: i + 1,
                    id: c.id,
                    name: c.name,
                    value: c.variationValues.filter(a=> a.active === true).map(a => a.value).join(','),
                    actions: (
                        <div
                           style={{ fontSize: 'large', justifyContent: 'flex-start' }}
                        >
                           <GrEdit
                              style={{ marginLeft: 3 }}
                              title="Edit Variation"
                              onClick={() => hadnleEditVariant(c.id)}
                           />
                        </div>
                     ),
                }));
            }
            return <CustomDataTable columns={columns} data={variations} loading={loading} />
        },
        [data]
    );

    return (
        <Grid fluid={true}>
            <Row>
                <Col md={12}>
                    <Header
                        style={{
                            marginBottom: 40,
                            boxShadow: '0 0 5px rgba(0, 0 ,0, 0.05)',
                        }}
                    >
                        <Col md={4} xs={12}>
                            <Heading>Variations</Heading>
                        </Col>

                        <Col md={8} xs={12}>
                            <Row>
                                <Col md={8} xs={12}>
                                </Col>

                                <Col md={4} xs={12}>
                                    <Button
                                        onClick={() => openDrawer()}
                                        startEnhancer={() => <Plus />}
                                        overrides={{
                                            BaseButton: {
                                                style: () => ({
                                                    width: '100%',
                                                    borderTopLeftRadius: '3px',
                                                    borderTopRightRadius: '3px',
                                                    borderBottomLeftRadius: '3px',
                                                    borderBottomRightRadius: '3px',
                                                }),
                                            },
                                        }}
                                    >
                                        Add Variation
                                    </Button>
                                </Col>
                            </Row>
                        </Col>
                    </Header>
                    <Wrapper style={{ boxShadow: '0 0 5px rgba(0, 0 , 0, 0.05)' }}>
                        {table}
                    </Wrapper>
                </Col>
            </Row>
        </Grid>
    );
}

